export default __webpack_public_path__ + "static/11-a57265ab3fc8236a07883d03513438e4.png";